import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export const useSelectedClientActiveTreatmentPlanId = () =>
  useSelector((state: RootState) => state.clients?.selected?.active_treatment_plan_id ?? null);
